import { RESTAURANT, NAV_LINKS } from "@/data/menu";
import logoMark from "@/assets/logo-mark.png";
import { Instagram } from "lucide-react";

export function Footer({ onNavigate }) {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-olive text-cream overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid md:grid-cols-3 gap-12 pb-16">
          <div>
            <img src={logoMark} alt="Udupi Paakamane" className="h-24 w-auto mb-5 opacity-95 drop-shadow-[0_2px_10px_rgba(0,0,0,0.15)]" />
            <p className="font-kannada text-xl text-cream/90">{RESTAURANT.nameKannada}</p>
            <p className="font-body text-sm text-cream/60 mt-2">{RESTAURANT.tagline}</p>
            <a
              data-testid="footer-instagram-link"
              href={RESTAURANT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-5 rounded-full border border-cream/25 px-4 py-2 text-sm font-body text-cream/85 hover:bg-cream hover:text-olive transition-colors duration-300"
            >
              <Instagram size={16} />
              Follow us on Instagram
            </a>
          </div>

          <div>
            <p className="font-body text-xs uppercase tracking-widest text-cream/50 mb-4">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => onNavigate(l.id)}
                    className="font-display text-2xl text-cream/85 hover:text-cream transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-body text-xs uppercase tracking-widest text-cream/50 mb-4">Find Us</p>
            <address className="not-italic font-body text-sm text-cream/70 leading-relaxed space-y-1">
              {RESTAURANT.addressLines.map((l) => (
                <span key={l} className="block">{l}</span>
              ))}
            </address>
            <a
              href={`tel:${RESTAURANT.phone.replace(/\s/g, "")}`}
              className="inline-block mt-4 font-display text-2xl text-cream hover:text-cream/80 transition-colors"
            >
              {RESTAURANT.phone}
            </a>
            <p className="font-body text-sm text-cream/70 mt-2">{RESTAURANT.hours} · Daily</p>
          </div>
        </div>

        <div className="border-t border-cream/15 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-cream/50">
            © {year} Udupi Paakamane. All rights reserved.
          </p>
          <p className="font-body text-xs text-cream/50">Pure Veg Cafe · Banashankari, Bengaluru</p>
        </div>
      </div>

      {/* Oversized brand wordmark */}
      <div className="select-none pointer-events-none px-6 md:px-12 pb-6">
        <p className="font-display text-[19vw] leading-[0.8] text-cream/10 whitespace-nowrap">
          Paakamane
        </p>
      </div>
    </footer>
  );
}
